module.exports = __webpack_public_path__ + "static/media/products.c79248b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/products.svg
// module id = 2151
// module chunks = 0